<template>
 <div class="home">
  <Navbar :is-active="1"></Navbar>
   <div class="body">
     <CommercialSidebar active="incidencias" />
     <div class="body__containt">
       <div class="page__title">
         <open-arrow></open-arrow>
         <h2>Aplicacion</h2>
       </div>
       <div class="page__filters">
        <input type="text" placeholder="Código de Incidencia" v-model="code" @keyup="search">
        <div style="display: flex; flex-direction:column; margin-top: -2rem;">
          <label>Fecha de Registro</label>
          <input type="date" v-model="created_at" @change="search"/>
        </div>
        <input type="text" placeholder="Codigo de boleta quick" v-model="code_invoice" @keyup="search">
        <input type="text" placeholder="DNI" v-model="dni" @keyup="search">
        <input type="text" placeholder="Nombre" v-model="nombre" @keyup="search">
        <input type="text" placeholder="Apellido" v-model="apellido" @keyup="search">
        <p @click="clean_filter()" class="clean_filter">Limpiar Filtros</p>
       </div>
       <div class="page__buttons">
         <ButtonExport
           :data="branchoffice"
           :columns="columns"
           :sheet-name="'Datos Socio Comercial'"
           :file-name="'Reporte Socio Comercial'"
         />
       </div>
       <div class="page__table" style="height: 100%; overflow: auto">
         <div class="table-headers">
           <p>Código de Incidencia</p>
           <p>Fecha registro</p>
           <p>DNI</p>
           <p>Nombre</p>
           <p>Apellido</p>
           <p>Telefono</p>
           <p>Tipo incidencia</p>
           <p>Estado</p>
           <p>Acciones</p>
         </div>
         <div class="table-body">
           <div class="data" v-for="branch of branchoffice" v-bind:key="branch.id">
             <p>{{ codeFormat(branch.id) }}</p>
             <p>{{ dateFormat(branch.created_at) }}</p>
             <p>{{ branch.dni}}</p>
             <p>{{ branch.name}}</p>
             <p>{{ branch.last_name}}</p>
             <p>{{ branch.cellphone}}</p>
             <p>{{ branch.incidence_description }}</p>
             <p>{{ branch.incidence_status_name }}</p>
             <div class="dropdown" >
                  <button class="button" @click="show('id-dropdown-content'+branch.id)">
                    <i class="fa fa-ellipsis" style="color: red"></i>
                  </button>
                  <div @mouseleave="show('id-dropdown-content'+branch.id)" class="dropdown-content" :id="'id-dropdown-content'+branch.id">
                    <router-link :to="{ path: '/ShowIncidenceAdmin', query: { id: branch.id }}" class="dropdown-item">
                      <i class="far fa-eye " ></i> Ver Detalle
                    </router-link>     
                  </div>
              </div>
           </div>
           <div style="text-align: center;" v-if="empty">
             <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
           </div>
         </div>
       </div>
       <div class="page__pagination">
         <Pagination
             :data="pagination"
             v-on:changePage="handleClickInParent"
         />
       </div>
     </div>
   </div>
 </div>

</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Navbar from '@/components/NavBar'
import Dropdown from '@/components/Dropdown.vue';
import Pagination from '@/components/Pagination.vue';
import OpenArrow from '@/components/OpenArrow.vue';
import CommercialSidebar from '@/components/CommercialSidebar.vue'
import ButtonExport from '@/components/ButtonExport.vue'
import { dateFormat } from '@/utils/formats'
import { codeFormat } from '@/utils/formats'
import $ from 'jquery'

export default {
 name: 'Incidencias',
 components: {
   Dropdown,
   Pagination,
   OpenArrow,
   CommercialSidebar,
   ButtonExport,
   Navbar
 },
 data() {
   return {
     code: '',
      role: localStorage.getItem('role'),
     dni: '',
     nombre: '',
     apellido: '',
     cellphone: '',
     created_at: '',
     pagination: [],
     code_invoice: '',
     created_at: '',
     branch_inside_mall: '',
     type: 'incidenciaAdmin',
     branchoffice:[],
     empty: false,
     usuario: '',
     columns: [
       { label: 'Código de Incidencia', field: 'id' },
       { label: 'Fecha de Registro', field: 'created_at' },
       { label: 'DNI', field: 'dni' },
       { label: 'Nombre', field: 'name' },
       { label: 'Apellido', field: 'last_name' },
       { label: 'Teléfono', field: 'cellphone' },
       { label: 'Tipo de Incidencia', field: 'incidence_description' },
       { label: 'Estado', field: 'incidence_status_name' },
     ]
   }
 },
  created() {
   this.getall();
   this.usuario = localStorage.getItem('usuario');
   this.company_name = localStorage.getItem('company_name');
   this.getDate();
 },
 computed:{
   // search: function () {
   //   let temp_branch_id = this.branchoffice.filter((item) => item.id.toString().toLowerCase().includes(this.id.toLowerCase()));
   //   let temp_branch_dni = temp_branch_id.filter((item) => item.user_doc_number.toLowerCase().includes(this.dni.toLowerCase()));
   //   let temp_branch_nombre = temp_branch_dni.filter((item) => item.user_name.toLowerCase().includes(this.nombre.toLowerCase()));
   //   return temp_branch_nombre.filter((item) => item.user_lastname.toLowerCase().includes(this.apellido.toLowerCase()));
   //
   // }
 },

 methods:{
  show(divID){
    if (!$("body").hasClass("cerrarModal")){
      $('#'+divID).fadeIn();
      setTimeout(function () {
        $("body").addClass("cerrarModal");
      }, 10);
    }
    },
    backCompany(){
      this.$router.push('/comercial')
    },
  clean_filter(){
    this.code = '';
    this.created_at = '';
    this.code_invoice = '';
    this.dni = '';
    this.nombre = '';
    this.apellido = '';
    this.getall();
  },
   codeFormat,
   dateFormat,
   search: function() {
     clearTimeout(this.timeout);
     var self = this;
     this.timeout = setTimeout(function () {
       let paramSearch = {
         code: self.code,
         dni: self.dni,
         nombre: self.nombre,
         apellido: self.apellido,
         created_at: self.created_at,
         code_invoice: self.code_invoice,
       }
       this.getall(1, paramSearch)
     }.bind(this), 500);
   },
   zeroFill(number, width) {
       width -= number.toString().length
       if (width > 0) {
         return (
             new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
         )
       }
       return number + ''
     },
   getDate() {
       let dias = [
         'Lunes',
         'Martes',
         'Miercoles',
         'Jueves',
         'Viernes',
         'Sabado',
         'Domingo'
       ]
       let meses = [
         'Enero',
         'Febrero',
         'Marzo',
         'Abril',
         'Mayo',
         'Junio',
         'Julio',
         'Agosto',
         'Septiembre',
         'Octubre',
         'Noviembre',
         'Diciembre'
       ]

       let date = new Date()

       const fechaNum = date.getDate()
       const mes_name = date.getMonth()

       let day = date.getDay() === 0 ? 6 : date.getDay() - 1
       this.fecha = dias[day] + ' ' + this.zeroFill(fechaNum, 2) + ' de ' + meses[mes_name]
     },
   handleClickInParent: function(page) {
     this.getall(page)
   },
   changePage(url) {
     this.$router.push(url)
   },
   handleClick(){
     localStorage.removeItem('token')
     this.$router.push('/login')
   },
   backCompany(){
     this.$router.push('/comercial')
   },
   addBranchOffice(){
     this.$router.push('/addbranchoffice')
   },
   async getall(page = 1, paramSearch = {}) {
     await axios.get('general/incidence',{
       params: {
         page: page,
         incidence_company_id:localStorage.getItem('company_id'),
         id: (paramSearch.code) ? paramSearch.code : null,
         user_doc_number: (paramSearch.dni) ? paramSearch.dni : null,
         user_name: (paramSearch.nombre) ? paramSearch.nombre : null,
         user_lastname: (paramSearch.apellido) ? paramSearch.apellido : null,
         fecha: (paramSearch.created_at) ? paramSearch.created_at : null,
         code_invoice: (paramSearch.code_invoice) ? paramSearch.code_invoice : null,
       },
       headers: {
         'Authorization': `Bearer ${localStorage.getItem('token')}`
       }}).then( res => {
       if (res.data.data.total > 0){
         this.branchoffice = res.data.data.data
         this.pagination = res.data.data
         this.empty = false
       }else{
         this.branchoffice = {}
         this.pagination = {}
         this.empty = true
       }
     })
   },
 }
}


</script>

<style scoped>
.back_company {
 background: #000;
 color: white;
 width: 100%;
 padding-top: 3%;
 padding-left: 10%;
}

/*------NAVBAR------*/
.home {
 width: 100vw;
 height: 100vh;
 display: flex;
 flex-direction: column;
 font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
 width: 100%;
 height: 120px;
 display: flex;
 justify-content: flex-start;
 flex-wrap: nowrap;
 align-items: center;
 border-bottom: 1px solid #dbdbdb;
 box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
 width: 200px;
 height: 100%;
 display: flex;
 justify-content: center;
 align-items: center;
}

.home .navbar__left img {
 width: 130px;
}

.home .navbar__center {
 width: 70%;
 height: 100%;
}

.home .navbar__center ul{
 width: 100%;
 height: 100%;
 display: flex;
 list-style: none;
 display: flex;
 justify-content: flex-start;
}
.home .navbar__center ul li {
 text-decoration: none;
 height: 100%;
 display: flex;
 justify-content: center;
 align-items: center;
 margin: 0 10px;
 position: relative;
 cursor: pointer;
}

.home .navbar__center ul li.active {
 color: #ff3128;
}
.home .navbar__center ul li.active::before {
 width: 100%;
}

.home .navbar__center ul li::before {
 content: '';
 position: absolute;
 bottom: 0;
 width: 0;
 height: 4px;
 background-color: #ff3128;
 transition: .3s ease;
}
.home .navbar__center ul li:hover {
 color: #ff3128;
}
.home .navbar__center ul li:hover::before {
 width: 100%;
}

.home .navbar__right {
 display: flex;
}
.home .navbar__right .profile {
 display: flex;
 width: 300px;
 height: 100%;
}

.home .navbar__right .profile__detail{
 width: 220px;
 height: 100%;
 display: flex;
 flex-direction: column;
 justify-content: center;
 padding: 0 5px;
}
.home .navbar__right .profile__detail p {
 margin: 0;
}
.home .navbar__right .profile__detail span {
 color: #938f8f;
 font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
 width: 40px;
 display: flex;
 justify-content: center;
 align-items: center;
 font-size: 25px;
 color: #ff3128;
 cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
/*-------------------------*/

/*------BODY------*/

.body {
 width: 100%;
 height: 600px;
 display: flex;

}
.body__sidebar,
.body__containt  {
 height: calc(100vh - 120px);
 box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
 width: 400px;
 position: relative;
 display: flex;
 flex-direction: column;
}
.page__title{
 display: flex;
 gap: .5rem;
}
.body__sidebar .floating-icon {
 position: absolute;
 right: -15px;
 top: 30px;
 color: #ff3128;
 font-size: 30px;
}
.page__title .floating-icon{
 right: -15px;
 top: 30px;
 color: #ff3128;
 font-size: 30px;
}
.page__title h2{
 margin-top: 6px;
}
.body__sidebar.open{
 display: none;
}
.body__sidebar .title {
 width: 100%;
 height: 140px;
 border-bottom: 1px solid #b6b6b6;
 display: flex;
 align-items: center;
 justify-content: center;
}
.body__sidebar .title__icon {
 color: #ff3128;
 font-size: 20px;
}
.body__sidebar .title__text {
 margin: 0 10px;

}

.body__sidebar .title__text h2 {
 font-size: 20px;
 margin: 0;
}
.body__sidebar .title__text p {
 margin: 0;
 font-weight: 300;
}

.body__sidebar .tabs {
 width: 100%;
 display: flex;
 flex-direction: column;
 align-items: center;
 height: calc(100% - 140px);
 padding-top: 5px;
}

.body__sidebar .tabs .tab {
 width: 90%;
 height: 70px;
 border-radius: 10px;
 color: #707070;
 display: flex;
 align-items: center;
 padding: 0 20px;
 margin-bottom: 10px;
 cursor: pointer;
 transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
 color: #ff3128;
 background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
 font-size: 20px;
 margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
 margin: 0;
 font-weight: 600;
}

.body__containt {
 width: 100%;
 display: flex;
 flex-direction: column;
 padding: 20px 30px;
}

.body__containt .page__title {
 width: 100%;
 margin-bottom: 20px;
}

.body__containt .page__title h2 {
 font-weight: 600;
 color: #ff3128;
 font-size: 25px;
}

.body__containt .page__filters {
 display: flex;
 justify-content: flex-start;
 flex-wrap: wrap;
 gap: 20px;
 margin-bottom: 2rem;
}
.body__containt .page__filters input {
 border-radius: 10px;
 border: 1px solid #e4e4e4;
 background: #fff;
 padding: 15px 20px;
 /* margin: 0 10px; */
}

.body__containt .page__buttons {
 width: 100%;
 display: flex;
 justify-content: flex-end;
 gap: 20px;
}

.body__containt .page__buttons .button {
 width: 250px;
 padding: 15px 20px;
 border-radius: 15px;
 font-size: 17px;
 color: #fff;
 border: none;
 display: flex;
 align-items: center;
 justify-content: space-between;
}
.body__containt .page__buttons .button:nth-child(1) {
 background: #32ba7c;
}
.body__containt .page__buttons .button:nth-child(2) {
 background: #ff3128;
}
.body__containt .page__buttons .button:nth-child(3) {
 background: #262626;
}

.body__containt .page__table {
 width: 100%;
 min-height: 200px;
 display: flex;
 flex-direction: column;
 margin-top: 50px;
}

.body__containt .page__table .table-headers {
 width: 100%;
 height: 50px;
 display: flex;
 justify-content: center;
 border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
 width: calc(100% / 7);
 display: flex;
 justify-content: center;
 align-items: center;
 font-weight: 600;
}

.body__containt .page__table .table-body {
 width: 100%;
 display: flex;
 flex-direction: column;
 border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-body .data {
 width: 100%;
 display: flex;
}
.body__containt .page__table .table-body .data p {
 width: calc(100% / 7);
 display: flex;
 justify-content: center;
 align-items: center;
 font-weight: 300;
 margin: 10px 0;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
 color: #ff3128;
}
/* .body__containt .page__filters input:nth-child(1) {
 width: 300px;
 margin: 0;
 margin-right: 10px;
} */


/*------BODY------*/
.body__sidebar.open{
 display: none;
}
.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}
</style>

